import { render, staticRenderFns } from "./SearchItemsHeader.vue?vue&type=template&id=6e9a6eb2&"
import script from "./SearchItemsHeader.vue?vue&type=script&lang=js&"
export * from "./SearchItemsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports